import { useLazyQuery } from '@apollo/react-hooks'
import Error from '@components/Error'
import { InstructorsQueryResult } from '@interfaces/Instructor'
import InstructorProfileLayout from '@layouts/Scheduling/Instructors/Profile'
import { GET_INSTRUCTORS_BY_PROGRAM_ID } from '@queries/getInsructorsByProgramId'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useMemo } from 'react'
import { FMIStudentProfileContext } from '../context'
import InstructorsLoader from '../InstructorsLoader'
import { FMIBulkSelectInstructorsProvider } from '../BulkForm/SelectInstructors/useSelectInstructors'
import { FMIBulkFormProvider } from '../BulkForm/Form/useFMIBulkForm'

const InstructorProfileWrapper: React.FC = () => {
  const router = useRouter()
  const { userProfileLoading, userProfileError, userProfile, currProgram } = useContext(FMIStudentProfileContext)
  const [getInstructors, { error, loading, data }] = useLazyQuery<InstructorsQueryResult>(
    GET_INSTRUCTORS_BY_PROGRAM_ID,
    {
      fetchPolicy: 'no-cache',
    }
  )

  useEffect(() => {
    try {
      if (userProfile && router.query.programId) {
        getInstructors({
          variables: {
            query: {
              StudentProfileId: userProfile?.SFId,
              ProgramId: router.query.programId,
            },
          },
        })
      }
    } catch (e) {
      console.error(e)
    }
  }, [userProfile?.SFId, router.query.programId])

  const Component = useMemo(
    () =>
      userProfile ? (
        <FMIBulkSelectInstructorsProvider>
          <FMIBulkFormProvider Program={currProgram}>
            <InstructorProfileLayout loading={loading} instructors={data?.getInstructorsByProgramId || []} />
          </FMIBulkFormProvider>
        </FMIBulkSelectInstructorsProvider>
      ) : null,
    [userProfile, loading, data?.getInstructorsByProgramId, currProgram]
  )

  return (
    <>
      {userProfileError || error ? <Error statusCode="400" /> : userProfileLoading ? <InstructorsLoader /> : Component}
    </>
  )
}

export default InstructorProfileWrapper
